export default {
  title: 'Media',
  sections: {
    main: {
      fields: {
        value: {
          title1: 'Medien',
          text1: 'Herzlich willkommen in unserem Medienbereich! Hier finden Sie alle wichtigen Informationen und Materialien für Ihre Berichterstattung über unser Unternehmen. Wir freuen uns über Ihr Interesse und stehen Ihnen für Rückfragen jederzeit zur Verfügung.',
          title2: 'Medienmitteilungen',
          text2: 'In diesem Bereich finden Sie unsere aktuellen und archivierten Pressemitteilungen. Sie können die Texte und zugehörigen Bilder, Logos und Infografiken herunterladen und für Ihre Berichterstattung nutzen.',
          buttonLabel1: 'Zu den Medienmitteilungen',
          buttonLink1: '/blog/category/press',
          title3: 'Bild- und Logomaterial',
          text3: 'Wir stellen Ihnen eine Auswahl an hochauflösenden Bildern und Logos zur Verfügung, die Sie für Ihre redaktionelle Berichterstattung über unser Unternehmen verwenden können. Bitte beachten Sie unsere Nutzungsbedingungen für die Verwendung dieser Materialien.',
          buttonLabel2: 'Zum Bild- und Logomaterial',
          buttonLink2: 'https://drive.google.com/drive/u/0/folders/11a7xT-MEqGzzOoDc3XjYgQnDLmyM6wTh',
          title4: 'Medienartikel und -beiträge',
          text4: 'Entdecken Sie eine Sammlung von Artikeln und Beiträgen über unser Unternehmen, die in verschiedenen Medien erschienen sind. Nutzen Sie die Such- und Filterfunktion, um gezielt nach Themen, Medien oder Zeitraum zu suchen.',
          buttonLabel3: 'Zur Mediensammlung',
          buttonLink3: 'https://drive.google.com/drive/u/0/folders/11a7xT-MEqGzzOoDc3XjYgQnDLmyM6wTh',
          title5: 'Medienkontakt',
          text5: 'Für weitere Informationen oder Anfragen stehen Ihnen unsere Medienkontakte zur Verfügung. Zögern Sie nicht, uns zu kontaktieren - wir freuen uns darauf, Ihnen behilflich zu sein.',
          memberName: 'Marco Quinter',
          memberNumber: '+41 (0) 79 402 91 11',
          memberEmail: 'marco.quinter@seu.ch',
          text6: 'Wir bedanken uns für Ihr Interesse an unserem Unternehmen und freuen uns auf eine erfolgreiche Zusammenarbeit.',
        },
      }
    }
  }
}
